import { useShallow } from 'zustand/react/shallow'
import { useA11yStore } from '../store'
import type { A11yPrefs } from '../types'

interface UseA11yReturn {
  prefs: A11yPrefs
  cycleControl: (key: keyof A11yPrefs) => void
  setWidgetEnabled: (enabled: boolean) => void
  resetAll: () => void
}

export function useA11y(): UseA11yReturn {
  const prefs = useA11yStore(useShallow((state) => ({
    widgetEnabled: state.widgetEnabled,
    textSize: state.textSize,
    cursorSize: state.cursorSize,
    contrast: state.contrast,
    motion: state.motion,
    dyslexia: state.dyslexia,
    focus: state.focus,
  })))

  const cycleControl = useA11yStore((state) => state.cycleControl)
  const setWidgetEnabled = useA11yStore((state) => state.setWidgetEnabled)
  const resetAll = useA11yStore((state) => state.resetAll)

  return {
    prefs,
    cycleControl,
    setWidgetEnabled,
    resetAll,
  }
}
